"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _form = require("../form");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PasswordForm = function PasswordForm(_ref) {
  var onSubmit = _ref.onSubmit,
    submitLoading = _ref.submitLoading,
    termsOfUseUrl = _ref.termsOfUseUrl,
    privacyPolicyUrl = _ref.privacyPolicyUrl;
  var _useTranslation = (0, _reactI18next.useTranslation)('libAuth'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_form.PasswordForm, {
    withTerms: true,
    onSubmit: onSubmit,
    termsOfUseUrl: termsOfUseUrl,
    privacyPolicyUrl: privacyPolicyUrl
  }, /*#__PURE__*/_react.default.createElement(_form.FormButton, {
    id: "signup-password",
    loading: submitLoading,
    color: "secondary"
  }, t('signUp')));
};
exports.PasswordForm = PasswordForm;